module.exports = __webpack_public_path__ + "img/27.ea79985f.png";